var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.level !== 'h7' && _vm.level !== 'h8')?_c(_vm.level,{tag:"component",class:['heading', _vm.light ? 'light' : 'dark']},[_vm._t("default")],2):(_vm.level === 'h7' || _vm.level === 'h8')?_c('p',{class:['heading', _vm.level, _vm.light ? 'light' : 'dark']},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }